export default "__VITE_ASSET__c7706de1__"